(ns frontend.view.components.power-search.highlight.view
  (:require
   [clojure.string :as s]))

(defn parse-parts
  [os-highlighted-text]
  (loop [parts []
         rest-text os-highlighted-text]
    (let [start-tag "<em>"
          end-tag "</em>"
          start-tag-index (s/index-of (or rest-text "") start-tag)
          end-tag-index (s/index-of (or rest-text "") end-tag)
          match-is-start-tag? (if (and start-tag-index end-tag-index)
                                (< start-tag-index end-tag-index)
                                (boolean start-tag-index))
          match-start-index (if match-is-start-tag? start-tag-index end-tag-index)]
      (if match-start-index
        (let [match-end-index (+ match-start-index
                                 (count (if match-is-start-tag? start-tag end-tag)))
              before (subs rest-text 0 match-start-index)
              after (subs rest-text match-end-index)]
          (recur (conj parts before) after))
        (conj parts rest-text)))))

(defn highlighted-parts-total-length
  [os-highlighted-text]
  (let [highlighted-parts (->> os-highlighted-text
                               (parse-parts)
                               (map-indexed (fn [i part] [i part]))
                               (filter (comp odd? first))
                               (map second))]
    (->> highlighted-parts
         (map count)
         (reduce +))))

(defn highlight
  [os-highlighted-text]
  (into [:div
         {:class "w-full truncate"}]
        (->> os-highlighted-text
             (parse-parts)
             (map-indexed
              (fn [i part]
                (if (odd? i)
                  [:span
                   {:class "p-2 bg-base-regular"}
                   part]
                  [:span
                   {:class "relative"}
                   part]))))))
